import { useEffect, useState, useRef, useContext } from 'react';
import classes from './providerDashboard.module.scss';
import i18n from '../../utils/i18n';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import OverviewSection from './Sections/OverviewSection/OverviewSection';
import ClientsSection from './Sections/ClientsSection/ClientsSection';
import FinancesSection from './Sections/FinancesSection/FinancesSection';
import SubscriptionSection from './Sections/SubscriptionSection/SubscriptionSection';
import ProfileSection from './Sections/ProfileSection/ProfileSection';
import ProviderProgress from './components/ProviderProgress';
import ProfileTabProvider from './context/Provider';

// import SectionIconOverview from './images/section-icon-overview.svg';
import SectionIconClients from './images/section-icon-clients.svg';
// import SectionIconFinances from './images/section-icon-finances.svg';
import SectionIconSubscription from './images/section-icon-subscription.svg';
import SectionIconProfile from './images/section-icon-profile.svg';
import SectionIconLogout from './images/section-icon-logout.svg';
import axios from '../../shared/axios/axiosProxy';
import ACTIONS, {
	fetchProviderData,
	fetchProviderRequests,
	// addReqInfo,
} from '../../redux/action';
import { useSelector, useDispatch } from 'react-redux';
import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Menu,
	MenuItem,
} from '@mui/material';
import HamburgerMenuIcon from '../../images/icon-hamburger-menu.svg';
import InputContext from '../../context/inputContext';
// export interface ProviderProps {
// 	providerData: Object;
// }

const ProviderDashboard = () => {
	const dispatch = useDispatch();
	const providerData = useSelector((state) => state);
	const userData = useSelector((state) => state.userData);
	const [reqSorted, setReqSorted] = useState(false);
	const [activeSection, setActiveSection] = useState('profile');
	const [activeProfileTab, setActiveProfileTab] = useState('profilesettings');
	const [allCompleted, setAllCompleted] = useState(false);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [menuAnchor, setMenuAnchor] = useState(null);
	const [avatarMenuAnchor, setAvatarMenuAnchor] = useState(null);
	const prevFinishedRegistration = useRef(providerData.finishedRegistration);
	const JWT = localStorage.getItem('JWT');

	const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
	const { isChanged, setIsChanged } = useContext(InputContext);
	useEffect(() => {
		const handleResize = () => setScreenWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	// const reqInfo = useSelector((state) => state.reqInfo);
	const requests = useSelector((state) => state.requests);

	const fetchRequests = (data) => {
		dispatch(fetchProviderRequests(data));
	};

	const updateRequests = () => {
		fetchProviderRequests({
			JWT: JWT,
			id: userData.id,
		});
		sortRequests(requests);
	};

	const sortRequests = (requests) => {
		//console.log('sortRequests', requests);
		let reqInfo = {
			reqNumber: 0,
			open: 0,
			newCustomer: 0,
			reqSorted: {
				open: [],
				accepted: [],
				modified: [],
				confirmed: [],
				declined: [],
				rejected: [],
			},
		};
		let ID = userData?.id;
		if (!ID || !requests || !Array.isArray(requests)) {
			dispatch(
				ACTIONS.addReqInfo({
					data: reqInfo,
					stateObject: 'reqInfo',
				})
			);
			return;
		}
		requests.forEach((req) => {
			if (!req) return;
			reqInfo.reqNumber += 1;
			let reqStatus = '';
			let today = Date.parse(new Date());
			if (req.selected_providers && Array.isArray(req.selected_providers)) {
				req.selected_providers.forEach((prov) => {
					if (!prov) return;
					if (req.rfpdate) {
						req.timePassed = Math.floor(
							Math.abs(Date.parse(req.rfpdate) - today) / (1000 * 3600)
						);
					}
					if (prov.providerID === ID) {
						reqStatus = prov.requestStatus || '';
						if (prov.requestStatus === 'open') {
							reqInfo.open += 1;
						}
						if (prov.requestStatus === 'confirmed') {
							reqInfo.newCustomer += 1;
						}
						req.selected_providers = [prov];
					}
				});
			}
			// Only add to reqSorted if reqStatus is valid and exists in reqInfo.reqSorted
			if (reqStatus && reqInfo.reqSorted[reqStatus] !== undefined) {
				reqInfo.reqSorted[reqStatus] = [...reqInfo.reqSorted[reqStatus], req];
			}
		});
		for (let i in reqInfo.reqSorted) {
			if (Array.isArray(reqInfo.reqSorted[i])) {
				reqInfo.reqSorted[i] = reqInfo.reqSorted[i].reverse();
			}
		}
		dispatch(
			ACTIONS.addReqInfo({
				data: reqInfo,
				stateObject: 'reqInfo',
			})
		);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		//fetchProviderData(JWT);
		if (userData?.id) {
			let data = { JWT: JWT, id: userData.id };
			fetchRequests(data);
		}
		if (requests && Array.isArray(requests)) {
			sortRequests(requests);
		}
		setReqSorted(true);
	}, [activeSection]);

	// console.log('providerData', providerData);

	const submitToDB = async (field) => {
		let data = field ? field : providerData;
		axios
			.patch('/api/provider', JSON.stringify(data), {
				headers: {
					Authorization: `Bearer ${JWT}`,
					'Content-Type': 'application/json',
				},
			})

			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
				/*      this.props.fetchProviderData(this.state.JWT); */
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			})
			.catch((error) => console.log('submitToDB error', error));
	};

	const submitUserUpdate = async (field) => {
		let data = field ? field : userData;
		// console.log('USER DATA', data);
		axios
			.patch('/api/user', JSON.stringify(data), {
				headers: {
					Authorization: `Bearer ${JWT}`,
					'Content-Type': 'application/json',
				},
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.statusText);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response?.data || error);
			});
	};

	useEffect(() => {
		if (
			prevFinishedRegistration.current !== providerData.finishedRegistration
		) {
			prevFinishedRegistration.current = providerData.finishedRegistration;
			submitUserUpdate();
		}
	}, [providerData.finishedRegistration]);

	const addProviderInfo = (item) => {
		dispatch(ACTIONS.addProviderInfo(item));
	};

	const fetchProviderDataAction = (JWT) => {
		dispatch(fetchProviderData(JWT));
	};

	const handleLogout = () => {
		if (isChanged) {
			setLogoutDialogOpen(true);
		} else {
			window.location.href = '/signout';
		}
	};

	const handleSaveAndLogout = async () => {
		await submitToDB();
		setLogoutDialogOpen(false);
		window.location.href = '/signout';
	};

	const navItems =
		!providerData?.provider_package?.packageSize || providerData.provider_package.packageSize === ''
			? [
					// { label: i18n.t('provider.overview'), icon: SectionIconOverview, id: 'overview' },
					// {
					// 	label: i18n.t('provider.clients'),
					// 	icon: SectionIconClients,
					// 	id: 'clients',
					// },
					// { label: i18n.t('provider.finances'), icon: SectionIconFinances, id: 'finances' },
					{
						label: i18n.t('provider.profile'),
						icon: SectionIconProfile,
						id: 'profile',
					},
			  ]
			: [
					// { label: i18n.t('provider.overview'), icon: SectionIconOverview, id: 'overview' },
					{
						label: i18n.t('provider.clients'),
						icon: SectionIconClients,
						id: 'clients',
					},
					// { label: i18n.t('provider.finances'), icon: SectionIconFinances, id: 'finances' },
					{
						label: i18n.t('provider.profile'),
						icon: SectionIconProfile,
						id: 'profile',
					},
					{
						label: i18n.t('provider.subscription'),
						icon: SectionIconSubscription,
						id: 'subscription',
					},
			  ];
	const renderSectionContent = () => {
		switch (activeSection) {
			case 'overview':
				return <OverviewSection />;
			case 'clients':
				return <ClientsSection />;
			case 'finances':
				return <FinancesSection />;
			case 'subscription':
				return <SubscriptionSection submitToDB={submitToDB} />;
			case 'profile':
				return (
					<ProfileSection
						providerData={providerData}
						fetchProviderData={fetchProviderDataAction}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
					/>
				);
			default:
				return null;
		}
	};

	const packages = {
		basic: i18n.t('provider.entrypackage'),
		advanced: i18n.t('provider.marketingpackage'),
		premium: i18n.t('provider.guaranteedpackage'),
	};

	return (
		<ProfileTabProvider>
			<div className={classes.dashboard}>
				<div className={classes.dashboardNavContainer}>
					<>
						<div className={classes.companyWrapper}>
							<Avatar
								src={providerData.provider_media?.profileImage || undefined}
								sx={{
									width: '38px',
									height: '38px',
									objectFit: 'cover',
									backgroundColor: 'transparent',
								}}>
								{!providerData.provider_media?.profileImage && (
									<AccountCircleIcon
										style={{ width: '38px', height: '38px' }}
									/>
								)}
							</Avatar>
							<div className={classes.companyDetails}>
								<div className={classes.companyDetailsTitle}>
									{providerData?.provider_info?.companyname || ''}
								</div>
								<div className={classes.companyDetailsSubTitle}>
									{providerData?.provider_package?.packageType
										? packages[providerData.provider_package.packageType] || ''
										: ''}
								</div>
							</div>
						</div>

						{screenWidth < 480 ? (
							<>
								<Button
									onClick={(e) => setMenuAnchor(e.currentTarget)}
									sx={{ width: '38px', height: '74px', borderRadius: '8px' }}>
									{/* {navItems.find((item) => item.id === activeSection)?.label} */}
									<img
										src={HamburgerMenuIcon}
										alt={i18n.t('general.hamburgerMenu')}
									/>
								</Button>
								<Menu
									anchorEl={menuAnchor}
									open={Boolean(menuAnchor)}
									onClose={() => setMenuAnchor(null)}
									slotProps={{
										paper: { sx: { borderRadius: '8px' } },
									}}>
									{navItems.map((item) => (
										<MenuItem
											key={item.id}
											onClick={() => {
												setActiveSection(item.id);
												setMenuAnchor(null);
											}}>
											{item.label}
										</MenuItem>
									))}
								</Menu>
								<Avatar
									src={providerData.provider_media?.profileImage || undefined}
									sx={{
										width: '38px',
										height: '38px',
										objectFit: 'cover',
										backgroundColor: 'transparent',
										marginRight: '18px',
										marginLeft: 'auto',
									}}
									onClick={(e) => setAvatarMenuAnchor(e.currentTarget)}>
									{!providerData.provider_media?.profileImage && (
										<AccountCircleIcon />
									)}
								</Avatar>
								<Menu
									anchorEl={avatarMenuAnchor}
									open={Boolean(avatarMenuAnchor)}
									onClose={() => setAvatarMenuAnchor(null)}
									slotProps={{
										paper: { sx: { borderRadius: '8px' } },
									}}>
									<MenuItem
										onClick={() => {
											window.location.href = '/signout';
										}}>
										{i18n.t('general.logout')}
									</MenuItem>
								</Menu>
							</>
						) : (
							<ul className={classes.navItems}>
								{navItems.map((item) => (
									<li
										key={item.id}
										className={`${classes.navItem} ${
											activeSection === item.id ? classes.navItemActive : ''
										}`}
										onClick={() => setActiveSection(item.id)}>
										<img
											src={item.icon}
											alt={`${item.label} icon`}
											className={classes.navIcon}
										/>
										{item.label}
									</li>
								))}
							</ul>
						)}
					</>
					<div style={{ marginTop: 'auto', marginBottom: '150px' }}>
						<ProviderProgress
							providerData={providerData}
							allCompleted={allCompleted}
							setAllCompleted={setAllCompleted}
						/>
					</div>
					<div className={classes.logout}>
						<div className={classes.logoutWrapper}>
							<span onClick={handleLogout} style={{ cursor: 'pointer' }}>
								<img
									src={SectionIconLogout}
									alt='LogoutIcon'
									className={classes.navIcon}
								/>
								{i18n.t('general.logout')}
							</span>
						</div>
					</div>

					<div className={classes.poweredbybk}>
						{i18n.t('general.poweredbybk')}
					</div>
					{logoutDialogOpen && (
						<Dialog
							open={logoutDialogOpen}
							onClose={() => setLogoutDialogOpen(false)}>
							<DialogTitle>{i18n.t('general.logout')}</DialogTitle>
							<DialogContent>
								<DialogContentText>
									{i18n.t('general.changeddatalogout')}
								</DialogContentText>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => (window.location.href = '/signout')}>
									{i18n.t('general.logout')}
								</Button>
								<Button onClick={handleSaveAndLogout}>
									{i18n.t('general.saveandexit')}
								</Button>
							</DialogActions>
						</Dialog>
					)}
				</div>

				{renderSectionContent()}
			</div>
		</ProfileTabProvider>
	);
};

export default ProviderDashboard;
